const OPEN_ANCHOR_EVENT = 'open-anchor-target';
const ACCORDION_ANIMATION_MS = 320;
const MAX_RENDER_ATTEMPTS = 20;

export const getFragmentId = (hash) => {
  if (!hash || hash === '#') return '';
  try {
    return decodeURIComponent(hash.slice(1));
  } catch {
    return hash.slice(1);
  }
};

const scrollToTarget = (target) => {
  target.dispatchEvent(new CustomEvent(OPEN_ANCHOR_EVENT, { bubbles: true }));
  const insideCollapsedAccordion = target.closest('[data-accordion-expanded="false"]');

  window.setTimeout(
    () => target.scrollIntoView({ block: 'start', inline: 'nearest' }),
    insideCollapsedAccordion ? ACCORDION_ANIMATION_MS : 0
  );
};

export const scrollToCurrentFragment = (attempt = 0) => {
  const id = getFragmentId(window.location.hash);
  if (!id) return;

  const target = document.getElementById(id);
  if (target) {
    scrollToTarget(target);
  } else if (attempt < MAX_RENDER_ATTEMPTS) {
    window.requestAnimationFrame(() => scrollToCurrentFragment(attempt + 1));
  }
};

export const initFragmentNavigation = () => {
  window.addEventListener('hashchange', () => scrollToCurrentFragment());
};

export { OPEN_ANCHOR_EVENT };
